<template>
    <div class="genrbox jf_container">
        <el-row>
            <div class="con_L_Box">
                <div>
                    <div class="hu_1">
                        <span class="xinzenghuiyuan_1" style="border-color: #8CBB77;">&nbsp;个人信息</span>
                    </div>
                </div>

                <div class="touxiangWrap">
                    <div class="sbTou">
                        <div class="ge_pic_icon_Infor cropped">
                            <img
                                class="touxiang"
                                style="width: 100%;height: auto"
                                :src="personmes.img"
                                alt
                            />
                        </div>
                        <div class="zhengS">
                            <p
                                class="shangcB"
                                data-toggle="modal"
                                @click="dialogVisible = true"
                            >更换头像</p>
                        </div>
                    </div>
                    <div class="genrbox_userinfo">
                        <p class="xinxiList">
                            <strong>员工ID：</strong>
                            <span class="xingming" >{{personmes.user_id}}</span>
                        </p>
                        <p class="xinxiList">
                            <strong>姓名：</strong>
                            <span class="xingming" id="xingm1">{{personmes.username}}</span>
                        </p>
                        <p class="xinxiList">
                            <strong>职位：</strong>
                            <span class="xiaoming" id="xingm2">{{personmes.gangwei}}</span>
                        </p>
                        <p class="xinxiList">
                            <strong>电话：</strong>
                            <span class="xingbei" id="huisex">{{personmes.phone}}</span>
                        </p>
                        <p class="xinxiList">
                            <strong>一阶段培训：</strong>
                            <span class>{{personmes.scoresb|peiz}}</span>
                        </p>
                        <!-- <p class="xinxiList"><strong>二维码：</strong><span class="xingming" id="huibir"></span></p> -->
                    </div>
                </div>
                <div class="jf-grjl_left">
                    <ul class="paiming" v-if="myIntegral">
                        <li style="margin-right:60px">
                            <p>{{myIntegral.month_rank}}</p>
                            <p>本月排名</p>
                        </li>
                        <li>
                            <p>{{myIntegral.year_rank}}</p>
                            <p>年度排名</p>
                        </li>
                        <li style="margin-left:60px">
                            <p>{{myIntegral.all_rank}}</p>
                            <p>累计排名</p>
                        </li>
                    </ul>
                    <p class="jifenNum">
                        <span class="numTitle">当前总积分</span>
                        <span class="num">
                            <b>{{myIntegral.point_all}}</b>分
                        </span>
                    </p>
                    <p class="jifenNum">
                        <span class="numTitle">本月奖励</span>
                        <span class="num">
                            <b>{{myIntegral.scoreinc}}</b>分
                        </span>
                    </p>
                    <p class="jifenNum">
                        <span class="numTitle">本月扣分</span>
                        <span class="num">
                            <b>{{myIntegral.scoredec}}</b>分
                        </span>
                    </p>
                    <p class="jifenNum">
                        <span class="numTitle">可兑换积分</span>
                        <span class="num">
                            <b>{{myIntegral.point_last}}</b>分
                        </span>
                    </p>
                    <div class="btnWrap">
                         <!--<button class="jiluBtn" @click="showPopup=1">兑换记录</button>-->
                         <button class="duihuanBtn" @click="showPopup=1">兑换记录</button>
                         <button class="duihuanBtn" @click="showPopup=2">积分兑换</button>
                        <button
                            class="duihuanBtn"
                            @click="dialogVisible5=true;getInfo(personmes.user_id)"
                        >信息查看</button>
                        <button class="duihuanBtn" @click="jump">积分申请</button>
                    </div>
                </div>
                <!-- <div style="text-align: center">
                    <br>
                    <img style="width: 100px" :src="personmes.erwm" alt="">
                </div>-->
            </div>
            <div style="float:left;width:calc(100% - 360px);">
                <div class="rightBox">
                    <div class="myshenBtn" style="width: 150px" @click="shenpi=true">我的审批</div>
                    <!-- <div  class="hu_1" >
                        <div  class="xinzenghuiyuan_1" style="border-color: #8CBB77;">&nbsp; 个人简介
                            <p class="bianjBtn" v-if="bianj" @click="bianj=false" >编辑</p>
                            <p class="bianjBtn" v-if="!bianj" @click="bianjdan" >完成</p>
                        </div>
                    </div>-->
                    <!-- <pre style="min-height:30px;max-height:150px;box-sizing: border-box;padding: 10px;" v-if="bianj" >{{personmes.content}}</pre> -->
                    <!--
                    <textarea name="" id="" cols="30"  v-show="!bianj" ref="count" v-model="personmes.content" maxlength="500" class="el-input__inner" style="height: 150px;line-height: 20px">
                            {{personmes.content}}
                    </textarea>
                    <p style="text-align: right" >{{numberlength}}/500</p>-->
                    <!-- 右侧表格 -->
                    <div class="jf-grjl_mian clearfix">
                        <div class="tableOp kaohe jf_conditionBox">
                            <mySearch
                                class="my-search"
                                @searchData="searchData"
                                :paramData="searchParam"
                                searchApi="point_staff_center/index"
                                v-model="searchContent"
                            ></mySearch>
                            <el-date-picker
                                class="picker"
                                v-model="date"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期"
                                value-format="yyyy-MM-dd"
                                @change="searchParam.date=date;getAllIntegral()"
                            ></el-date-picker>
                            <el-select
                                class="topSelect"
                                v-model="searchParam.typeid"
                                placeholder="请选择分类"
                                clearable
                                @change="getAllIntegral()"
                            >
                                <el-option
                                    v-for="item in assortArray"
                                    :key="item.id+1000"
                                    :label="item.typename"
                                    :value="item.id"
                                >
                                    <span :class="{'secondary': item.pid!==0}">{{item.typename}}</span>
                                </el-option>
                            </el-select>
                        </div>
                        <div class="jf-grjl_right">
                            <!-- 数据表格 -->
                            <el-table class="elTable" :data="integralTable" height="75%">
                                <el-table-column
                                    prop="typename"
                                    label="积分分类"
                                    align="center"
                                    :show-overflow-tooltip="true"
                                ></el-table-column>
                                <el-table-column
                                    prop="rule_name"
                                    label="规则名称"
                                    align="center"
                                    :show-overflow-tooltip="true"
                                ></el-table-column>
                                <el-table-column
                                    prop="rule_des"
                                    label="积分细则"
                                    align="center"
                                    :show-overflow-tooltip="true"
                                ></el-table-column>
                                <el-table-column label="奖惩分数" align="center">
                                    <template slot-scope="scope">
                                        <span
                                            :style="{'color':scope.row.rule_type==1?'#67C23A':'#F56C6C'}"
                                        >{{scope.row.rule_type==1?'+':'-'}}{{scope.row.score}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="标准分数" align="center">
                                    <template slot-scope="scope">
                                        <span>{{scope.row.score_type == 1 ? scope.row.score_fixed: scope.row.score_min+' ~ '+scope.row.score_max}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="check_time" label="申请日期" align="center"></el-table-column>
                            </el-table>
                            <!-- 页码 -->
                            <p
                                class="pageTotal"
                            >共有 {{pageData.count}} 条记录 当前 {{pageData.page}} 页/共 {{pageData.pagetotal}} 页</p>
                            <el-pagination
                                class="pageBody"
                                @current-change="changePage"
                                background
                                layout="prev, pager, next"
                                :total="pageData.count*1"
                            ></el-pagination>
                        </div>
                    </div>
                    <div class="hu_1">
                        <div class="xinzenghuiyuan_1" style="border-color:#78c6c6;">
                            &nbsp; 获奖证书
                            <p class="bianjBtn" @click="submitUpload">上传</p>
                        </div>
                    </div>
                    <div class="zhengsbox">
                        <div v-for="(pimg,iindex) in  allimg" class="shanbox" :key="iindex">
                            <el-button
                                size="mini"
                                icon="el-icon-close"
                                class="shanBtn"
                                @click="shantu(pimg)"
                                circle
                            ></el-button>
                            <img
                                :src="pimg.img"
                                :preview="0"
                                style="width: 100px;height: 100px;cursor: pointer"
                                alt
                            />
                        </div>
                    </div>
                    <!--上传部分-->
                    <div id="imageszhengshu">
                        <el-upload
                            class="upload-demo"
                            ref="upload"
                            name="images"
                            :on-preview="handlePictureCardPreview"
                            list-type="picture-card"
                            :action="prodEnv + 'saas/yuangon/shangchuan'"
                            :data="{token:token}"
                            :file-list="fileList"
                            :on-success="uploadok"
                            :auto-upload="false"
                        >
                            <i class="el-icon-plus"></i>
                        </el-upload>
                        <el-dialog :visible.sync="dialogVisible1">
                            <img width="100%" :src="dialogImageUrl1" alt />
                        </el-dialog>
                    </div>
                    <!--上传部分-->
                </div>
            </div>
        </el-row>

        <el-dialog class="tanchuang" :visible.sync="dialogVisible" width="280px">
            <span slot="title" class="dialog-footer">选择头像</span>
            <div style="width: 200px;margin:0 auto;">
                <croppa v-model="croppa" placeholder="点击上传，或拖拽上传" :placeholder-font-size="14"></croppa>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="success" @click="upload">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog
            class="tanchuang shenpiclass"
            :visible.sync="shenpi"
            width="510px"
            :close-on-click-modal="false"
        >
            <span slot="title" class="dialog-header">我的审批</span>
            <div style="position: relative;overflow: hidden">
                <div class="shenhetop" style="width: 100%">
                    <p class="shenpititle">未审批</p>
                    <p class="shenpititle">已审批</p>
                </div>
                <div style="width:100%;" class="shenpibox">
                    <div class="shenplrbox">
                        <div class="shenplist" v-for="(wei,index) in weishenpi" :key="index">
                            <p class="shenplistname">{{wei.username}}</p>
                            <p class="shijian font12">{{wei.c_time}}</p>
                            <el-collapse>
                                <el-collapse-item>
                                    <template slot="title">修改前：</template>
                                    <div class="shijian">
                                        <p
                                                class="font12"
                                                v-if="wei.x_zeng_ke!=wei.zeng_ke"
                                        >赠课：{{wei.zeng_ke}}节</p>
                                        <p
                                                class="font12"
                                                v-if="wei.tai==2"
                                        >排课开始时间：{{wei.y_start_time}}</p>
                                        <p
                                                class="font12"
                                                v-if="wei.tai==2"
                                        >排课结束时间：{{wei.y_end_time}}</p>
                                        <p
                                                class="font12"
                                                v-if="(wei.tai!=2)&&(wei.x_create_time!=wei.create_time)"
                                        >合同开始时间：{{wei.create_time}}节</p>
                                        <p
                                                class="font12"
                                                v-if="(wei.tai!=2)&&(wei.x_e_time!=wei.e_time)"
                                        >合同结束时间：{{wei.e_time}}节</p>
                                        <p
                                                class="font12"
                                                v-if="wei.x_zeng_ke!=wei.zeng_ke"
                                        >赠课：{{wei.zeng_ke}}节</p>
                                        <p
                                                class="font12"
                                                v-if="wei.x_s_name!=wei.zeng_ke"
                                        >课时包：{{wei.s_name}}</p>
                                        <p class="font12" v-if="wei.x_bz!=wei.bz">备注：{{wei.bz}}</p>
                                        <p
                                                class="font12"
                                                v-if="wei.x_uname!=wei.y_uname"
                                        >销售人：{{wei.y_uname}}</p>
                                    </div>
                                </el-collapse-item>
                                <el-collapse-item>
                                    <template slot="title">修改后：</template>
                                    <div class="shijian">
                                        <p
                                            class="font12"
                                            v-if="wei.x_zeng_ke!=wei.zeng_ke"
                                        >赠课：{{wei.x_zeng_ke}}节</p>
                                        <p
                                            class="font12"
                                            v-if="wei.tai==2"
                                        >排课开始时间：{{wei.x_start_time}}</p>
                                        <p
                                            class="font12"
                                            v-if="wei.tai==2"
                                        >排课结束时间：{{wei.x_end_time}}</p>
                                        <p
                                            class="font12"
                                            v-if="(wei.tai!=2)&&(wei.x_create_time!=wei.create_time)"
                                        >合同开始时间：{{wei.x_create_time}}</p>
                                        <p
                                            class="font12"
                                            v-if="(wei.tai!=2)&&(wei.x_e_time!=wei.e_time)"
                                        >合同结束时间：{{wei.x_e_time}}</p>
                                        <p
                                            class="font12"
                                            v-if="wei.x_zeng_ke!=wei.zeng_ke"
                                        >赠课：{{wei.x_zeng_ke}}节</p>
                                        <p
                                            class="font12"
                                            v-if="wei.x_s_name!=wei.zeng_ke"
                                        >课时包：{{wei.x_s_name}}</p>
                                        <p class="font12" v-if="wei.x_bz!=wei.bz">备注：{{wei.x_bz}}</p>
                                        <p
                                            class="font12"
                                            v-if="wei.x_uname!=wei.y_uname"
                                        >销售人：{{wei.x_uname}}</p>
                                    </div>
                                </el-collapse-item>
                            </el-collapse>
                            <button v-if="personmes.gangwei == '园长' || personmes.gangwei == '投资人'" class="btn btn-xs btn-success" style="margin: 10px 10px;" @click="agree_examine(wei.id,wei.tai,wei.xj_id)">同意</button>
                            <button v-if="personmes.gangwei == '园长' || personmes.gangwei == '投资人'" class="btn btn-xs btn-danger" style="margin: 10px 10px;" @click="refuse(wei.id,wei.tai,wei.xj_id)">不同意</button>
                        </div>
                    </div>
                    <div class="shenplrbox">
                        <div class="shenplist" v-for="(we,index) in weishenpi2" :key="index">
                            <p class="shenplistname">{{we.username}}</p>
                            <p class="shijian font12">{{we.c_time}}</p>
                            <el-collapse>
                                <el-collapse-item>
                                    <template slot="title">修改前：</template>
                                    <div class="shijian">
                                        <p
                                                class="font12"
                                                v-if="we.x_zeng_ke!=we.zeng_ke"
                                        >赠课：{{we.zeng_ke}}节</p>
                                        <p
                                                class="font12"
                                                v-if="we.tai==2"
                                        >排课开始时间：{{we.y_start_time}}</p>
                                        <p class="font12" v-if="we.tai==2">排课结束时间：{{we.y_end_time}}</p>
                                        <p
                                                class="font12"
                                                v-if="(we.tai!=2)&&(we.x_create_time!=we.create_time)"
                                        >合同开始时间：{{we.create_time}}节</p>
                                        <p
                                                class="font12"
                                                v-if="(we.tai!=2)&&(we.x_e_time!=we.e_time)"
                                        >合同结束时间：{{we.e_time}}节</p>
                                        <p
                                                class="font12"
                                                v-if="we.x_zeng_ke!=we.zeng_ke"
                                        >赠课：{{we.zeng_ke}}节</p>
                                        <p
                                                class="font12"
                                                v-if="we.x_s_name!=we.zeng_ke"
                                        >课时包：{{we.s_name}}</p>
                                        <p class="font12" v-if="we.x_bz!=we.bz">备注：{{we.bz}}</p>
                                        <p
                                                class="font12"
                                                v-if="we.x_uname!=we.y_uname"
                                        >销售人：{{we.y_uname}}</p>
                                    </div>
                                </el-collapse-item>
                                <el-collapse-item>
                                    <template slot="title">修改后：</template>
                                    <div class="shijian">
                                        <p
                                            class="font12"
                                            v-if="we.x_zeng_ke!=we.zeng_ke"
                                        >赠课：{{we.x_zeng_ke}}节</p>
                                        <p
                                            class="font12"
                                            v-if="we.tai==2"
                                        >排课开始时间：{{we.x_start_time}}</p>
                                        <p class="font12" v-if="we.tai==2">排课结束时间：{{we.x_end_time}}</p>
                                        <p
                                            class="font12"
                                            v-if="(we.tai!=2)&&(we.x_create_time!=we.create_time)"
                                        >合同开始时间：{{we.x_create_time}}</p>
                                        <p
                                            class="font12"
                                            v-if="(we.tai!=2)&&(we.x_e_time!=we.e_time)"
                                        >合同结束时间：{{we.x_e_time}}</p>
                                        <p
                                            class="font12"
                                            v-if="we.x_zeng_ke!=we.zeng_ke"
                                        >赠课：{{we.x_zeng_ke}}节</p>
                                        <p
                                            class="font12"
                                            v-if="we.x_s_name!=we.zeng_ke"
                                        >课时包：{{we.x_s_name}}</p>
                                        <p class="font12" v-if="we.x_bz!=we.bz">备注：{{we.x_bz}}</p>
                                        <p
                                            class="font12"
                                            v-if="we.x_uname!=we.y_uname"
                                        >销售人：{{we.x_uname}}</p>
                                    </div>
                                </el-collapse-item>
                            </el-collapse>

                            <p class="shijian font12">
                                审批:
                                <span
                                    style="color: #1bd524;"
                                    class="font12"
                                    v-if="we.x_status=='同意'"
                                >{{we.x_status}}</span>
                                <span
                                    style="color: red;"
                                    class="font12"
                                    v-if="we.x_status=='不同意'"
                                >{{we.x_status}}</span>
                            </p>

                            <el-collapse v-if="we.x_status=='不同意'">
                                <el-collapse-item>
                                    <template slot="title">理由：</template>
                                    <p class="shijian font12">{{we.liyou}}</p>
                                </el-collapse-item>
                            </el-collapse>
                        </div>
                    </div>
                </div>
            </div>

            <!--<span slot="footer" class="dialog-footer">-->
            <!--<el-button @click="shenpi = false">取 消</el-button>-->
            <!--<el-button type="success" >确 定</el-button>-->
            <!--</span>-->
        </el-dialog>
        <!-- 兑换、记录弹窗 -->
        <div class="myDialog duihuan_dialog" v-if="showPopup">
            <div
                class="myDialog_content shenqing-myDialog_content"
                :style="{'width': showPopup===1?'700px':'500px'}"
            >
                <h4 class="myDialog_h">
                    {{showPopup === 1?'兑换记录':'请选择兑换礼品'}}
                    <i
                        class="close el-icon-circle-close-outline el-icon-circle-close"
                        @click="showPopup=0"
                    ></i>
                </h4>
                <div v-if="showPopup===2">
                    <p class="canExchange">
                        可兑换积分：
                        <span>{{myIntegral.point_last}}</span>
                    </p>
                    <h5 class="duihuanTitle">现金(每季度兑换一次)</h5>
                    <div class="inp_wrap">
                        <label>积分数:</label>
                        <el-input
                            type="number"
                            v-model="exchangeMoney"
                            :style="{'width':myIntegral.exchange == 'no'?'170px!important':'150px!important'}"
                            :placeholder="myIntegral.exchange == 'no'?myIntegral.point_last==0?'积分不足':myIntegral.point_exchange_time+'后可兑换':''"
                            :disabled="myIntegral.exchange == 'no'?true:false"
                        ></el-input>&nbsp;
                    </div>
                    <h5 class="duihuanTitle">礼品</h5>
                    <div class="inp_wrap">
                        <label>商品名称:</label>
                        <button class="showGoodsBtn" @click="dialogzeng=true">请选择商品</button>
                    </div>
                    <ul class="giftImg" v-if="giftData.length>0">
                        <li v-for="(img, index) in giftData" :key="index+600">
                            <i class="el-icon-error" @click="deleteGoods(index)"></i>
                            <img :src="img" alt="gift" />
                        </li>
                    </ul>
                    <div class="btnWrap">
                        <button class="assort_confim-btn" @click="showPopup=0">取消</button>
                        <button class="assort_confim-btn confim" @click="submitExchange">确定</button>
                    </div>
                </div>
                <div v-else>
                    <el-date-picker
                        class="picker"
                        v-model="exchangeTIme"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        value-format="yyyy-MM-dd"
                        @change="getExchangeRecord()"
                    ></el-date-picker>
                    <el-table class="duihuanTable" :data="exchangeTable" height="400">
                        <el-table-column prop="point" label="兑换积分" align="center"></el-table-column>
                        <el-table-column
                            prop="gift"
                            label="礼品"
                            align="center"
                            :show-overflow-tooltip="true"
                        ></el-table-column>
                        <el-table-column
                            prop="create_time"
                            label="时间"
                            align="center"
                            :show-overflow-tooltip="true"
                        ></el-table-column>
                        <el-table-column prop="username" label="操作人" align="center"></el-table-column>
                    </el-table>
                    <!-- 页码 -->
                    <p
                        class="pageTotal"
                    >共有 {{exchangePage.count}} 条记录 当前 {{exchangePage.page}} 页/共 {{exchangePage.pagetotal}} 页</p>
                    <el-pagination
                        class="pageBody"
                        @current-change="getExchangeRecord()"
                        background
                        layout="prev, pager, next"
                        :total="exchangePage.count*1"
                    ></el-pagination>
                </div>
            </div>
        </div>
        <!-- 添加赠品图片弹框 -->
        <el-dialog
            id="newlist"
            class="mynewlist"
            title="title"
            :visible="dialogzeng"
            width="80%"
            center
        >
            <span slot="title" class="dialog-title">
                <div class="demo-input-suffix all">
                    <el-row>
                        <el-col :span="12">
                            <div class="grid">
                                全部分类:
                                <el-select
                                    class="all_kind"
                                    size="small"
                                    style="width: 160px;"
                                    v-model="search.kind"
                                    clearable
                                    placeholder="全部分类"
                                    @change="loaddata"
                                >
                                    <el-option
                                        v-for="item in good_types"
                                        :key="item.id"
                                        :label="item.type_name"
                                        :value="item.id"
                                    ></el-option>
                                </el-select>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div
                                class="grid gridnimei"
                                style="width: 180px;"
                                @keyup.enter="searchname"
                            >
                                <el-input
                                    class="all_kind"
                                    size="small"
                                    placeholder="请输入商品名称"
                                    v-model="search.name"
                                >
                                    <div slot="append" class="el-icon-search" @click="searchname"></div>
                                </el-input>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </span>
            <span>
                <el-table
                    ref="multipleTable"
                    :data="tableData.data"
                    tooltip-effect="dark"
                    style="width: 100%"
                    @selection-change="handleSelectionChange"
                    height="440px"
                    border
                >
                    <el-table-column type="selection" width="30"></el-table-column>
                    <el-table-column prop="good_num" label="商品编号" width="150" align="center"></el-table-column>
                    <el-table-column prop="good_name" label="商品名称" align="center"></el-table-column>
                    <!-- <el-table-column label="图片" align="center">
                        <template slot-scope="scope">
                            <span>
                                <img
                                    :src="scope.row.mini_imgpath"
                                    style="height: 30px;width: 30px;"
                                />
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="spec" label="规格" align="center"></el-table-column>-->
                    <el-table-column prop="unit" label="单位" align="center"></el-table-column>
                    <el-table-column prop="exchange_integral" label="兑换积分" align="center"></el-table-column>
                    <el-table-column prop="stock" label="可用库存" align="center"></el-table-column>
                    <el-table-column prop="limit" width="120" label="兑换数量" align="center">
                        <template slot-scope="scope" style="line-height:20px">
                            <el-input-number
                                size="mini"
                                v-model="scope.row.limit"
                                :min="0"
                                :max="scope.row.stock"
                                label="描述文字"
                            ></el-input-number>
                        </template>
                    </el-table-column>
                </el-table>

                <p class="pager">
                    <span>共{{tableData.total}}条记录</span>
                    当前{{tableData.page}}页/共{{tableData.totalpage}}页
                </p>
                <el-pagination
                    class="f_page"
                    background
                    @current-change="handleCurrentChange"
                    :current-page="tableData.page"
                    layout="prev, pager, next"
                    :total="tableData.total"
                ></el-pagination>
            </span>
            <span slot="footer" class="dialog-footer">
                <el-row>
                    <el-col :span="12">
                        <div style="padding-left: 200px">
                            <el-button @click="dialogzeng = false">取 消</el-button>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div style="padding-right: 200px">
                            <el-button type="success" @click="getgift">确 定</el-button>
                        </div>
                    </el-col>
                </el-row>
            </span>
        </el-dialog>
        <!-- 信息查看 弹窗 -->
        <el-dialog
            class="tanchuang ziliaoBox"
            :visible.sync="dialogVisible5"
            width="830px"
            :close-on-click-modal="false"
        >
            <span slot="title" class="dialog-footer">信息查看</span>
            <div style="padding-left: 20px;">
                <el-row>
                    <el-col :span="8">
                        <div class="prolist">
                            <div class="tit">姓名</div>
                            <el-input
                                v-model="archives.username"
                                size="medium"
                                disabled="disabled"
                                placeholder="请输入内容"
                                style="width: 150px"
                            ></el-input>
                        </div>
                    </el-col>

                    <el-col :span="8">
                        <div class="prolist">
                            <div class="tit">职位</div>
                            <el-input
                                v-model="archives.gangwei"
                                size="medium"
                                disabled="disabled"
                                placeholder="请输入内容"
                                style="width: 150px"
                            ></el-input>
                        </div>
                    </el-col>

                    <el-col :span="8">
                        <div class="prolist">
                            <div class="tit">电话</div>
                            <el-input
                                v-model="archives.phone"
                                size="medium"
                                disabled="disabled"
                                placeholder="请输入内容"
                                style="width: 150px"
                            ></el-input>
                        </div>
                    </el-col>
                </el-row>

                <el-row style="margin-top: 20px">
                    <el-col :span="8">
                        <div class="prolist">
                            <div class="tit">入职时间&nbsp;</div>
                            <el-date-picker
                                style="width: 150px"
                                v-model="archives.ruzhi"
                                align="right"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择入职时间"
                            ></el-date-picker>
                        </div>
                    </el-col>

                    <el-col :span="8">
                        <div class="prolist">
                            <div class="tit">学历&nbsp;</div>
                            <el-select
                                v-model="archives.xueli"
                                placeholder="请选择学历"
                                style="width: 150px"
                            >
                                <el-option
                                    v-for="item in xueliOption"
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                ></el-option>
                            </el-select>
                        </div>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="24" style="margin-top: 10px">
                        <div class="prolist">
                            <div style="width: 100px">总部认证培训:</div>
                            <el-row style="width: 660px;padding-top:4px;">
                                <el-col :span="24">
                                    <!-- <el-checkbox-group v-model="archives.zongbu">
										<el-checkbox label="一阶培训"></el-checkbox>
										<el-checkbox label="二阶培训"></el-checkbox>
										<el-checkbox label="三阶培训"></el-checkbox>
                                    </el-checkbox-group>-->
                                    <ul class="zbrenzhengWrap">
                                        <div
                                            class="zbrenzheng"
                                            :class="{'activeRz': archives.scoresb==1}"
                                        >一阶培训</div>
                                        <div
                                            class="zbrenzheng"
                                            :class="{'activeRz': archives.scoresc==1}"
                                        >二阶培训</div>
                                        <div
                                            class="zbrenzheng"
                                            :class="{'activeRz': archives.scoresd==1}"
                                        >三阶培训</div>
                                    </ul>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="24" style="margin-top: 10px">
                        <div class="prolist">
                            <div style="width: 100px">其他认证培训:</div>
                            <el-row style="width: 660px;padding-top:4px;">
                                <el-col :span="24">
                                    <el-checkbox-group v-model="archives.renzheng">
                                        <el-checkbox label="感统培训"></el-checkbox>
                                        <el-checkbox label="测评证书"></el-checkbox>
                                        <el-checkbox label="云编程证书"></el-checkbox>
                                    </el-checkbox-group>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="24" style="margin-top: 10px">
                        <div class="prolist">
                            <div style="width: 100px">兼职事项:</div>
                            <el-row style="width: 660px;padding-top:4px;">
                                <el-col :span="24">
                                    <el-checkbox-group v-model="archives.jianzhi">
                                        <el-checkbox label="采购"></el-checkbox>
                                        <el-checkbox label="HR招聘"></el-checkbox>
                                        <el-checkbox label="公众号运营"></el-checkbox>
                                        <el-checkbox label="库管"></el-checkbox>
                                        <el-checkbox label="财务" style="width:90px"></el-checkbox>
                                    </el-checkbox-group>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="24" style="margin-top: 10px">
                        <div class="prolist">
                            <div style="width: 100px">特长:</div>
                            <el-row style="width: 660px;padding-top:4px;">
                                <el-col :span="24">
                                    <el-checkbox-group v-model="archives.techang">
                                        <el-checkbox label="英语4级及以上"></el-checkbox>
                                        <el-checkbox label="舞蹈考级证书"></el-checkbox>
                                        <el-checkbox label="乐器考级证书"></el-checkbox>
                                        <el-checkbox label="主持认证证书"></el-checkbox>
                                    </el-checkbox-group>
                                </el-col>
                            </el-row>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <span slot="footer" class="dialog-footer">
                <div class="xzyg" style="margin:0 auto" @click="dialogVisible5=false">返回</div>
            </span>
            <div class="mask"></div>
        </el-dialog>
    </div>
</template>

<script>
import mySearch from "../components/mySearch.vue";
var baseUrl = process.env.apiUrl + "point/";
export default {
    data() {
        return {
            shenpi: false,
            tanchuang: false,
            dialogVisible: false,
            croppa: {},
            fileList: [],
            bianj: true,
            dialogImageUrl: "",
            personmes: "",
            numberlength: "",
            base64: "",
            token: "",
            allimg: [],
            options: [],
            dialogImageUrl1: "",
            dialogVisible1: false,
            weishenpi: "",
            weishenpi2: "",
            // ---------------------------------
            integralTable: [],
            showPopup: 0, // 显示弹窗  1-兑换记录   2-兑换
            date: "",
            searchParam: {
                from: 1,
                date: "",
                shenhe: 1,
                typeid: ""
            },
            searchContent: "",
            assortArray: [],
            pageData: {
                count: "", // 总条数
                page: 1, // 当前页
                pagetotal: "" // 总页数
            }, // 页数
            myIntegral: "", // 左侧个人积分
            exchangeTable: [],
            exchangeTIme: "",
            exchangePage: {
                count: "", // 总条数
                page: 1, // 当前页
                pagetotal: "" // 总页数
            },
            //  商品弹窗内变了
            dialogzeng: false,
            search: {
                kind: "",
                name: ""
            },
            tableData: {
                data: [],
                page: 1,
                total: 0,
                totalpage: 10
            },
            good_types: [],
            multipleSelection: [],
            selectedGift: [],
            giftData: [],
            exchangeMoney: "",
            dialogVisible5: false,
            archives: {
                username: "",
                user_id: "",
                xueli: "",
                ruzhi: "",
                jianzhi: [],
                techang: [],
                renzheng: [],
                gangwei: "",
                phone: "",
                scoresb: "",
                scoresc: "",
                scoresd: "",
                zongbu: []
            },
            xueliOption: ["本科以上", "本科", "专科、大专"],
            prodEnv: "",
            liyou:'无',
        };
    },
    created() {
        this.prodEnv = process.env.apiUrl;
    },
    methods: {
        shantu: function(img) {
            let self = this;
            $.ajax({
                url: process.env.apiUrl + "saas/yuangon/shan",
                data: {
                    img: img.img,
                    token: self.token
                },
                type: "POST",
                dataType: "json",
                success: function(data) {
                    if (data.status == 1) {
                        $.ajax({
                            url: process.env.apiUrl + "saas/yuangon/geren",
                            data: {
                                id: self.base64,
                                token: self.token
                            },
                            type: "POST",
                            dataType: "json",
                            success: function(data) {
                                self.personmes = data.data;
                                self.allimg = data.img;
                                self.$previewRefresh();
                            }
                        });
                    } else {
                        self.$message.success("删除失败！");
                    }
                }
            });
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        upload() {
            if (!this.croppa.hasImage()) {
                alert("您没有选择图片");
                return false;
            }
            this.base64 = this.croppa.generateDataUrl();
            //            this.personmes.images=this.base64;
            let self = this;
            $.ajax({
                url: process.env.apiUrl + "saas/yuangon/head",
                data: {
                    image: self.base64,
                    token: self.token
                },
                type: "POST",
                dataType: "json",
                success: function(data) {
                    if (data.status == 1) {
                        self.dialogVisible = false;
                        self.personmes.img = self.base64;
                    }
                }
            });
        },

        submitUpload() {
            this.$refs.upload.submit();
        },
        uploadok() {
            this.$message.success("上传成功！");
            // setTimeout(function () {
            //     location.reload();
            // },1000)
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        bianjdan: function() {
            this.bianj = true;
            let self = this;
            $.ajax({
                url: process.env.apiUrl + "saas/yuangon/edit",
                data: {
                    content: self.personmes.content,
                    token: self.token
                },
                type: "POST",
                dataType: "json",
                success: function(data) {
                    if (data.status != 1) {
                        self.$message.error("保存失败！");
                    } else {
                        self.$message.success("保存成功！");
                    }
                }
            });
        },
        // -------------------------------------------
        // 获取分类列表
        async getAssortList() {
            let that = this;
            try {
                let res = await that.$http.post(baseUrl + "point_type/index", {
                    token: that.token
                });
                if (res.status == 1) {
                    if (res.data && res.data.length > 0) {
                        that.assortArray = [];
                        res.data.forEach((element, index) => {
                            that.assortArray.push({
                                typename: element.typename,
                                pid: element.pid,
                                id: element.id
                            });
                            if (element.child && element.child.length > 0) {
                                element.child.forEach((ele, i) => {
                                    that.assortArray.push({
                                        typename: ele.typename,
                                        pid: ele.pid,
                                        id: ele.id
                                    });
                                });
                            }
                        });
                    }
                } else {
                    that.$message.error(res.msg);
                }
            } catch (err) {
                that.$message.error(err);
            }
        },
        // 获取全部积分列表
        async getAllIntegral() {
            let that = this;
            try {
                let res = await that.$http.post(
                    baseUrl + "point_staff_center/index",
                    {
                        token: that.token,
                        time_s:
                            that.date && that.date.length > 0
                                ? that.date[0]
                                : "",
                        time_e:
                            that.date && that.date.length > 0
                                ? that.date[1]
                                : "",
                        search: that.searchContent,
                        page: that.pageData.page,
                        typeid: that.searchParam.typeid
                    }
                );
                if (res.status == 1) {
                    that.integralTable = res.data;
                    that.pageData.count = res.map.count;
                    that.pageData.page = res.map.page;
                    that.pageData.pagetotal = res.map.pagetotal;
                } else {
                    that.$message.error(res.msg);
                }
            } catch (err) {
                that.$message.error(err);
            }
        },
        // 获取个人积分信息
        async getMyIntegral() {
            let that = this;
            try {
                let res = await that.$http.post(
                    baseUrl + "point_staff_center/score_ranking",
                    {
                        token: that.token
                    }
                );
                if (res.status == 1) {
                    that.myIntegral = res.data;
                } else {
                    that.$message.error(res.msg);
                }
            } catch (err) {
                that.$message.error(err);
            }
        },
        // 获取个人积分记录列表 兑换记录
        async getExchangeRecord() {
            let that = this;
            try {
                let res = await that.$http.post(
                    baseUrl + "point_staff_center/exchange_record",
                    {
                        token: that.token,
                        time_s:
                            that.exchangeTIme && that.exchangeTIme.length > 0
                                ? that.exchangeTIme[0]
                                : "",
                        time_e:
                            that.exchangeTIme && that.exchangeTIme.length > 0
                                ? that.exchangeTIme[1]
                                : "",
                        page: that.exchangePage.page
                    }
                );
                if (res.status == 1) {
                    that.exchangeTable = res.data;
                    that.exchangePage.count = res.map.count;
                    that.exchangePage.page = res.map.page;
                    that.exchangePage.pagetotal = res.map.pagetotal;
                } else {
                    that.$message.error(res.msg);
                }
            } catch (err) {
                that.$message.error(err);
            }
        },
        changePage(page) {
            this.pageData.page = page;
            this.getAllIntegral();
        },
        searchData(data) {
            this.integralTable = data.data;
            this.pageData.count = data.map.count;
            this.pageData.page = data.map.page;
            this.pageData.pagetotal = data.map.pagetotal;
        },
        handleShowPopup() {
            // if (this.myIntegral.exchange == "no") {
            //     this.$message.warning("您已兑换完成,请"+this.myIntegral.point_exchange_time+"下次再来兑换");
            //     return;
            //     this.show_exchangemoney = false;
            // }
            this.showPopup = 2;
        },
        // 商品弹窗函数
        // 搜索商品名称
        searchname() {
            this.tableData.page = 1;
            this.loaddata();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 添加赠品图片
        getgift() {
            let selectedImg = [];
            this.selectedGift = [];
            for (
                let index = 0;
                index < this.multipleSelection.length;
                index++
            ) {
                const element = this.multipleSelection[index];
                selectedImg.push(element.mini_imgpath);
                this.selectedGift.push({
                    id: element.id,
                    num: element.limit
                });
                //判断赠品限量是否填写 不能为0
                if (element.limit == 0) {
                    this.$message.warning("商品限量不能为零");
                    selectedImg = [];
                    this.selectedGift = {};
                    return false;
                }
            }
            this.dialogzeng = false;
            this.giftData = selectedImg;
        },
        // 赠品接口
        loaddata() {
            var arr = this;
            $.ajax({
                url: baseUrl + "point_staff_center/goods_list",
                type: "post",
                data: {
                    token: arr.token,
                    search: arr.search.name,
                    typeid: arr.search.kind,
                    page: arr.tableData.page
                },
                success: function(response) {
                    if (response.map.count == 0) {
                        arr.tableData.data = [];
                        arr.tableData.total = 0;
                        arr.tableData.totalpage = 1;
                    } else {
                        arr.tableData.data = response.data;
                        arr.tableData.total = response.map.count;
                        arr.tableData.totalpage = response.map.pagetotal;
                    }
                }
            });
        },
        handleCurrentChange(val) {
            this.tableData.page = val;
            this.loaddata();
        },
        async getGoodsType() {
            let that = this;
            try {
                let res = await that.$http.post(
                    baseUrl + "point_staff_center/goods_type",
                    { token: that.token }
                );
                if (res.status == 1) {
                    that.good_types = res.data;
                } else {
                    that.$message.error(res.msg);
                }
            } catch (err) {
                that.$message.error(err);
            }
        },
        deleteGoods(i) {
            this.giftData.splice(i, 1);
            this.selectedGift.splice(i, 1);
        },
        // 兑换提交
        async submitExchange() {
            if (this.exchangeMoney == "" && this.selectedGift.length === 0) {
                this.$message.warning("请兑换现金红包或者礼品");
                return;
            }
            let that = this;
            try {
                let res = await that.$http.post(
                    baseUrl + "point_staff_center/exchange_goods",
                    {
                        token: that.token,
                        score: that.exchangeMoney,
                        goods_id: that.selectedGift,
                        type: 2
                    }
                );
                if (res.status == 1) {
                    that.$message.success("兑换成功");
                    that.getMyIntegral();
                    that.getExchangeRecord();
                    that.exchangeMoney = "";
                    that.selectedGift = [];
                    that.giftData = [];
                    that.showPopup = 0;
                } else {
                    that.$message.error(res.msg);
                }
            } catch (err) {
                that.$message.error(err);
            }
        },
        jump() {
            let routeOne = this.$router.resolve({
                name: "shenqing"
            });
            window.open(routeOne.href, "_blank");
        },
        getInfo(id) {
            let loadingInstance = this.$loading();
            let that = this;
            $.ajax({
                url: process.env.apiUrl + "saas/yuangon/get_files",
                type: "post",
                data: {
                    user_id: id,
                    token: that.token
                },
                success: function(res) {
                    if (res.status == 1) {
                        that.archives = res.data;
                    } else {
                        that.$message.error(res.msg);
                    }
                },
                fail: function(err) {
                    that.$message.error(err);
                },
                complete: function() {
                    loadingInstance.close();
                }
            });
        },
        // 待审核修改事项确认同意
        agree_examine(id,tai,xj_id) {
            if (tai == 2) {
                id = xj_id;
            }
            let self = this
            $.ajax({
                // url: "https://yapid.gymbaby.org/index/audited/do_agree",
                url: "https://wxapi.momyhome.cn/index/audited/do_agree",
                type: 'POST',
                data: {
                    tai: tai,
                    id: id,
                },
                success: function(e) {
                    if (e.status == 1) {
                        // self.shenpi = false
                        self.$message.success('审核通过');
                        self.get_audi()
                    }else{
                        self.$message.error(e.msg)
                    }
                },
            });
        },
        // 待审核修改事项拒绝
        refuse(id,tai,xj_id) {
            if (tai == 2) {
                id = xj_id;
            }
            if (this.liyou == "") {
                this.$message('请填写理由');
                return;
            }
            let self = this
            $.ajax({
                // url: "https://yapid.gymbaby.org/index/audited/do_disagree",
                url: "https://wxapi.momyhome.cn/index/audited/do_disagree",
                type: 'POST',
                data: {
                    tai: tai,
                    id: id,
                    liyou: self.liyou
                },
                success: function(e) {
                    if (e.status == 1) {
                        // self.shenpi = false
                        self.liyou = '无';
                        self.$message.success('已提交！');
                        self.get_audi()
                    }else{
                        self.$message.error(e.msg)
                    }
                },
            });
        },
        get_audi(){
            let self = this;
            $.ajax({
                url: process.env.apiUrl + "saas/Mysh/index1",
                data: {
                    token: self.token
                },
                type: "POST",
                dataType: "json",
                success: function(data) {
                    self.weishenpi = data;
                }
            });
            $.ajax({
                url: process.env.apiUrl + "saas/Mysh/index2",
                data: {
                    token: self.token
                },
                type: "POST",
                dataType: "json",
                success: function(data) {
                    self.weishenpi2 = data;
                }
            });
        }
    },
    filters: {
        peiz: function(val) {
            if (val == 0) {
                return "未培训";
            }
            if (val == 1) {
                return "结业";
            }
            if (val == 2) {
                return "不合格";
            }
        }
    },
    watch: {
        //watch()监听某个值（双向绑定）的变化，从而达到change事件监听的效果
        // personmes:{
        //     handler:function(){
        //         var self = this;
        //         self.numberlength= self.$refs.count.value.length;
        //     },
        //     deep:true
        // }
    },
    components: {
        mySearch
    },
    mounted: function() {
        let self = this;
        self.token = self.$cookies.get("token");
        $.ajax({
            url: process.env.apiUrl + "saas/yuangon/geren",
            data: {
                id: self.base64,
                token: self.token
            },
            type: "POST",
            dataType: "json",
            success: function(data) {
                self.personmes = data.data;
                self.allimg = data.img;
                self.$previewRefresh();
            }
        });

        this.get_audi();
        $("#imageszhengshu")
            .find(".el-upload__input")
            .hide();
        // -----------------------------
        this.getMyIntegral();
        this.getAllIntegral();
        this.getAssortList();
        this.loaddata();
        this.getGoodsType();
        this.getExchangeRecord();
    }
};
</script>

<style scoped>
* {
    font-size: 14px;
}

.font12 {
    font-size: 12px;
}
.shanbox {
    position: relative;
}
.genrbox {
    padding: 10px 40px;
}
.shanBtn {
    position: absolute;
    right: -5px;
    top: -3px;
    padding: 2px;
}
.shanBtn > i {
    font-size: 20px !important;
}
.zhengsbox {
    min-height: 100px;
    display: flex;
    margin-bottom: 10px;
    flex-wrap: wrap;
}
.zhengsbox img {
    width: 100px;
    height: 100px;
    margin: 4px;
}
.shenplrbox .shenplist .shenplistname {
    color: #ff8a00;
    font-size: 12px;
}
.shenplrbox .shenplist {
    margin-bottom: 10px;
}

.shenplrbox {
    color: #999;
}

.touxiang {
    width: 100%;
    height: auto;
}

.con_L_Box {
    float: left;
    min-width: 356px;
    background: url(/static/qmsj/img/rightB.png) no-repeat;
    background-size: 2px 654px;
    background-position: center right;
}
.shenpiclass .el-dialog__body .shenpibox {
    background: url(/static/qmsj/img/rightB.png) no-repeat;
    background-size: 2px 90%;
    background-position: 252px center;
    display: flex;
    margin-top: 38px;
    height: 200px;
    overflow-x: hidden;

    overflow-y: auto;
}

.shenhetop {
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    position: absolute;
    left: 0;
    top: 0;
    z-index: 99999;
    background: #fff;
}

.xinzenghuiyuan_1 {
    width: 100%;
    height: 25px;
    display: block;
    font-size: 16px;
    border-left: 6px solid #8CBB77;
    margin-top: 12px;
    margin-bottom: 12px;
}
.sbTou {
    width: 100px;
    height: 100px;
    position: relative;
    /* margin: 80px auto 35px; */
    border-radius: 50px;
    overflow: hidden;
    background: rebeccapurple;
}
.shangcB {
    position: absolute;
    left: 0;
    bottom: 0;
    text-align: center;
    width: 100%;
    height: 30px;
    line-height: 30px;
    color: rgb(255, 255, 255);
    cursor: pointer;
    background: rgba(0, 0, 0, 0.6);
}
.xinxiList {
    padding-left: 20px;
    margin-top: 5px;
    width: 160px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.xingbei {
    color: rgb(102, 102, 102);
}

.myshenBtn {
    width: 195px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background: #8CBB77;
    color: #fff;
    margin: 26px auto 40px;
    border-radius: 15px;
    box-shadow: #cfcce4 0 3px 10px;
    cursor: pointer;
    font-size: 16px;
}
em,
i {
    font-style: normal;
}
.rightBox {
    box-sizing: border-box;
    padding-left: 40px;
}
.bianjBtn {
    float: right;
    width: 81px;
    height: 26px;
    line-height: 26px;
    text-align: center;
    color: #fff;
    border-radius: 13px;
    background: #8CBB77;
    cursor: pointer;
}

.shenList {
    line-height: 22px;
}
.shenpititle {
    line-height: 38px;
    width: 50%;
    font-size: 14px;
    color: #8CBB77;
    height: 38px;
    text-align: center;
}
#imageszhengshu .el-upload .el-upload__input {
    display: none;
}
</style>
<style lang="less">
.genrbox  {
    .tanchuang .el-dialog__body {
        padding: 15px;
    }
    .shenpiclass .el-dialog {
        overflow-x: hidden;
    }
    .shenpiclass .el-dialog__body {
        padding: 0;
        margin-right: -11px;
    }
    .shenpiclass .el-dialog__body .shenplrbox {
        padding: 16px;
        width: 50%;
        font-size: 12px;
    }
    .shenplist .el-collapse-item__header {
        border: none;
        height: auto;
        line-height: normal;
        font-size: 12px;
    }
    .shenplist .el-collapse-item__arrow {
        line-height: normal;
    }
    .shenplist .el-collapse {
        border: none;
    }
    .shenplist .el-collapse-item__content {
        color: #999;
        padding-bottom: 0;
        line-height: normal;
    }
    .shenplist .el-collapse-item__wrap {
        border: none;
    }
    .touxiangWrap {
        display: flex;
        align-items: center;
    }
    .sbTou {
        margin-left: 20px;
        margin: 0 20px 0 20px;
    }
    .picker,
    .my-search,
    .topSelect {
        float: left;
        margin-right: 10px;
    }
    .jf-grjl_mian {
        /* width: 100%; */
        /* min-width: 1100px; */
        height: calc(100vh - 212px);
        /* padding-left: 30px; */
        margin-bottom: 30px;
    }
    .jf-grjl_left {
        float: left;
        margin-top: 50px;
        width: 350px;
        /* height: calc(100vh - 168px); */
        overflow-y: scroll;
        background: #fff;
    }
    .jf-grjl_right {
        float: left;
        margin-left: 16px;
        width: 100%;
        /* width: calc(100% - 420px); */
        /* min-width: 600px; */
        /* max-width: 1000px; */
        height: calc(100vh - 218px);
        padding-top: 20px;
        background: #fff;
    }
    .jf-grjl_right .elTable {
        margin: 0 auto;
        width: 100%;
        min-width: unset;
    }
    .avatar {
        display: block;
        width: 88px;
        height: 88px;
        border-radius: 50%;
        margin: 38px auto 30px;
    }
    li {
        list-style: none;
    }
    .paiming {
        text-align: center;
        margin-bottom: 20px;
    }
    .paiming li {
        display: inline-block;
        width: 60px;
        height: 60px;
    }
    .paiming p {
        font-size: 14px;
        line-height: 30px;
        color: #999;
    }
    .paiming p:first-child {
        font-size: 20px;
        font-weight: 600;
        color: #333;
    }
    .jifenNum {
        height: 54px;
        padding: 0 33px;
        color: #999;
    }
    .numTitle {
        float: left;
        font-size: 14px;
        line-height: 36px;
    }
    .num {
        float: right;
        font-size: 14px;
        color: #333;
    }
    .num b {
        font-size: 20px;
    }
    .btnWrap {
        margin-top: 20px;
        text-align: center;
    }
    .jiluBtn,
    .duihuanBtn {
        margin: 15px 16px;
        width: 100px;
        height: 30px;
        border: none;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 600;
        color: #8CBB77;
        background: #f1f1f1;
        outline: none;
    }
    .duihuanBtn {
        color: #fff;
        background: #8CBB77;
    }
    .myDialog_content {
        width: 500px;
    }
    .close {
        float: right;
        margin: 8px 20px;
    }
    .duihuanTitle {
        margin: 30px 0 -10px 0;
        padding-left: 30px;
        font-size: 16px;
        font-weight: 700;
        color: #333;
    }
    .inp_wrap label {
        width: 70px;
    }
    .btnWrap {
        text-align: center;
    }
    .btnWrap .assort_confim-btn {
        display: inline-block;
        margin: 30px 20px 0;
    }
    .confim {
        color: #fff;
        background: #8CBB77;
    }
    .duihuanTable {
        margin: 20px;
        width: 90%;
    }
    .duihuan_dialog .picker {
        margin: 20px;
    }
    /* ****************************************************************************************** */
    #newlist .dialog-title {
        background-color: #8CBB77;
        width: 100%;
        height: 50px;
        display: inline-block;
        padding-top: 10px;
    }
    #newlist .el-dialog__header {
        padding: 0;
    }
    #newlist .all {
        color: white;
    }
    #newlist .el-table thead {
        color: #7c7f85;
    }
    #newlist .el-table td,
    #newlist .el-table th {
        padding: 0;
    }
    #newlist .el-checkbox__input.is-checked .el-checkbox__inner,
    #newlist .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: #8CBB77;
        border-color: #8CBB77;
    }
    #newlist .el-checkbox__inner:hover {
        border-color: #8CBB77;
    }
    #newlist .el-input-number--mini .el-input-number__decrease,
    #newlist .el-input-number--mini .el-input-number__increase {
        background: #fff;
        color: #8CBB77;
        border: 1px solid #8CBB77;
        border-radius: 50%;
        width: 18px;
        height: 18px;
        line-height: 16px;
        top: 8px;
        /* margin-left: 10px;
        margin-right: 10px; */
    }
    #newlist .el-checkbox__original {
        display: none;
    }
    #newlist .el-input-number--mini {
        width: 100px;
        line-height: 26px;
    }
    #newlist .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #8CBB77;
        color: #fff;
    }
    #newlist .el-pagination.is-background .btn-next,
    #newlist .el-pagination.is-background .btn-prev,
    #newlist .el-pagination.is-background .el-pager li {
        margin: 0;
    }
    #newlist .el-button--primary {
        color: #fff;
        background-color: #8CBB77;
        border-color: #8CBB77;
    }
    #newlist .el-button--primary:focus,
    #newlist .el-button--primary:hover {
        background: #8CBB77;
        border-color: #8CBB77;
        color: #fff;
    }
    #newlist .el-button {
        padding: 8px 15px;
    }
    #newlist .el-table__body {
        color: rgb(153, 153, 153);
    }
    .pager {
        color: rgb(153, 153, 153);
    }
    .pager span {
        margin-right: 5px;
    }
    .f_page {
        text-align: center;
    }
    #newlist .el-date-editor .el-range-input::placeholder {
        color: rgb(153, 153, 153);
    }
    #newlist .el-input__inner::placeholder {
        color: rgb(153, 153, 153);
    }
    #newlist .el-radio__input.is-checked .el-radio__inner {
        /* border-color: red; */
        background: #8CBB77;
        border: 0;
    }
    #newlist .el-radio__input.is-checked + .el-radio__label {
        color: rgb(153, 153, 153);
    }
    #newlist .el-radio {
        color: rgb(153, 153, 153);
        margin-left: 5px;
    }
    #newlist .el-radio__inner:hover {
        border-color: rgb(153, 153, 153);
    }
    #newlist .el-radio__label {
        padding-left: 5px;
    }
    #newlist .el-radio + .el-radio {
        margin-left: 15px;
    }
    #newlist .el-input-group__append {
        background: white;
        border-radius: 0 20px 20px 0;
        padding: 0 10px 0;
    }
    /*#newlist .el-input__inner{*/
    /*padding: 0 0 0 10px;*/
    /*}*/
    .my_span {
        width: 15px;
        height: 15px;
        border-radius: 50%;
        border: 1px solid rgb(153, 153, 153);
    }
    #newlist .el-table .cell {
        line-height: 15px;
    }
    #newlist .el-table th,
    .el-table tr {
        line-height: 25px;
    }
    #newlist .el-dialog--center .el-dialog__body {
        text-align: center;
    }
    #newlist .el-dialog--center .el-dialog__body {
        padding: 0;
    }
    .showGoodsBtn {
        outline: none;
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        width: 200px;
        height: 40px;
        font-size: 14px;
        background: none;
    }
    .giftImg {
        display: flex;
        flex-wrap: wrap;
        margin-top: 20px;
        width: 100%;
        padding: 0 30px;
    }
    .giftImg li {
        position: relative;
        margin: 8px 16px 8px 0;
    }
    .giftImg li i {
        position: absolute;
        top: -8px;
        right: -8px;
        width: 16px;
        height: 16px;
        font-size: 16px;
        cursor: pointer;
    }
    .giftImg li img {
        display: block;
        width: 60px;
        height: 50px;
    }
    .canExchange {
        position: absolute;
        top: 50;
        right: 14px;
        font-size: 14px;
    }
    .canExchange span {
        font-weight: 600;
        font-size: 16px;
    }
    .secondary {
        margin-left: 30px;
    }
    *::-webkit-scrollbar {
        display: none;
    }
    .tableOp {
        padding-left: 14px;
    }
    .ziliaoBox {
        border-radius: 20px;
    }
    .ziliaoBox .el-dialog__header {
        border-radius: 0 !important;
    }
    .prolist {
        height: 40px;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
    }
    .ziliaoBox .el-checkbox {
        width: 110px;
    }
    .ziliaoBox .el-checkbox + .el-checkbox {
        margin-left: 24px;
    }
    .xzyg {
        width: 135px;
        height: 32px;
        color: white;
        border-radius: 16px;
        text-align: center;
        line-height: 32px;
        background: #8CBB77;
        cursor: pointer;
    }
    .infoBox {
        border-radius: 4px;
        border: 1px solid #dcdfe6;
        width: 150px;
        height: 40px;
        line-height: 40px;
        text-align: center;
    }
    .tit {
        width: 70px;
        height: 40px;
        text-align: justify;
        line-height: 40px;
    }
    .tit:after {
        content: "";
        width: 100%;
        display: inline-block;
        overflow: hidden;
        height: 0;
    }
    .mask {
        width: 100%;
        height: 70%;
        position: absolute;
        top: 40px;
        left: 0;
        z-index: 9999;
    }
    .zbrenzhengWrap {
        display: flex;
    }
    .zbrenzheng {
        margin-right: 30px;
        width: 80px;
        height: 30px;
        text-align: center;
        line-height: 30px;
        color: #c0c4cc;
    }
    .activeRz {
        border: 1px solid #b3d8ff;
        border-radius: 4px;
        color: #8CBB77;
        background: #ecf5ff;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/geren.vue